import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { useCallback, useState } from 'react';
import { Tooltip, AppText, Row } from '..';
export function NetworkQualityBars(props) {
    const [showTooltip, setShowTooltip] = useState(false);
    const getNetworkQualityMessage = useCallback(() => {
        let message;
        switch (props.quality) {
            case 1:
                message = 'bad';
                break;
            case 2:
                message = 'poor';
                break;
            case 3:
                message = 'fair';
                break;
            case 4:
                message = 'good';
                break;
            case 5:
                message = 'great';
                break;
            default:
                message = 'unknown';
                break;
        }
        return message;
    }, [props.quality]);
    return (_jsx(Tooltip, { showTooltip: showTooltip, offsetValue: 50, distance: 15, message: _jsxs(AppText, { color: "dark", size: "small", as: "p", children: [props.remoteUsername.length ? `${props.remoteUsername}'s` : 'The', " network quality is ", getNetworkQualityMessage()] }), children: _jsx(Row, { width: "100%", height: "100%", padding: '5px 0', alignItems: 'flex-end', onMouseEnter: () => setShowTooltip(true), onMouseOver: () => setShowTooltip(true), onMouseOut: () => setShowTooltip(false), children: (() => {
                const bars = [];
                for (let i = 1; i <= 5; i++) {
                    bars.push(_jsx(Bar, { filled: props.quality >= i, index: i }, `bar-${i}`));
                }
                return bars;
            })() }) }));
}
const Bar = styled.div(({ filled, index }) => ({
    backgroundColor: filled ? 'white' : 'transparent',
    border: '1px solid white',
    width: '5px',
    marginRight: '2px',
    transition: 'background-color 0.5s',
    height: `${index * 4}px`,
}));
//# sourceMappingURL=network_quality_bars.js.map